import { graphql, useStaticQuery } from "gatsby";

const usePostsQuery = () => {
  const query = useStaticQuery(graphql`
    query {
      allWpPost(sort: { date: DESC }) {
        nodes {
          uri
          id
          slug
          title
          content
          excerpt
          date(formatString: "DD.MM.YYYY")
          acfPost {
            postUpdateDate
          }
          featuredImage {
            node {
              sourceUrl
            }
          }
          categories {
            nodes {
              name
              slug
            }
          }
          author {
            node {
              avatar {
                url
              }
              username
              firstName
              lastName
            }
          }
        }
      }
    }
  `);

  return query.allWpPost.nodes;
};

export default usePostsQuery;
